<BSpinner class="loading" variant="primary" label="Spinning"></BSpinner>